// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Text from 'components/form/text'
import Select from 'components/form/select'
import Checkbox from 'components/form/checkbox'

// Redux:
import { setAnimalsSearch, setAnimalsPostcode, setAnimalsPostcodeDistance, getLatLng, setLatLng, setAnimalsFilter, setAnimalsType } from 'actions/animals'
import { selectedAnimal } from 'selectors/animals'
import { currentPage } from 'selectors/page'

class AnimalsFilters extends React.Component {
	constructor() {
		super()

		this.state = {
			advanced: false
		}
	}

	handleSearchChange = ( id, value ) => {
		this.props.setAnimalsSearch( value )
	}

	handlePostcodeChange = ( id, value ) => {
		this.props.setAnimalsPostcode( value )

		if ( value.length == 4 ) {
			this.props.getLatLng( value )
		} else {
			this.props.setLatLng( '' )
		}
	}

	handlePostcodeDistanceChange = ( id, value ) => {
		const { postcode } = this.props

		this.props.setAnimalsPostcodeDistance( value )

		if ( postcode.length == 4 ) {
			this.props.getLatLng( postcode )
		}
	}

	handleFiltersChange = ( id, value ) => {
		if ( 'type' == id ) {
			this.props.setAnimalsType( value )
		} else {
			this.props.setAnimalsFilter( id, value )
		}
	}

	handleClickAdvanced = () => {
		this.setState({
			advanced: ! this.state.advanced
		})
	}

	render() {
		const { search, postcode, postcodeDistance, filters, subpage, animalsType, animalsById, page } = this.props
		const { advanced } = this.state
		let className = 'animal-filters',
			breedNames = [],
			breeds = [ {
			name: 'Any',
			value: ''
		} ]

		if ( advanced ) {
			className += ' has-advanced'
		}

		if ( animalsById && Object.keys( animalsById ).length ) {
			Object.keys( animalsById ).forEach( i => {
				if ( ! breedNames[ animalsById[ i ].breed ] ) {
					breedNames[ animalsById[ i ].breed ] = true

					breeds.push({
						name: animalsById[ i ].breed,
						value: animalsById[ i ].breed
					})
				}
			})
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<div className="-filters">
						{ ( 'adopted' != page.template && 'cat' == animalsType ) &&
							<Select
								id="coat_type"
								label="Hair"
								value={ filters.coat_type }
								options={[
									{
										name: 'Any',
										value: ''
									},
									{
										name: 'Long hair',
										value: 'Long'
									},
									{
										name: 'Medium hair',
										value: 'Medium'
									},
									{
										name: 'Short hair',
										value: 'Short'
									},
								]}
								onChange={ this.handleFiltersChange }
							/>
						}

						{ ( 'adopted' != page.template && 'cat' != animalsType ) &&
							<Select
								id="size"
								label="Size"
								value={ filters.size }
								options={[
									{
										name: 'Any',
										value: ''
									},
									{
										name: 'Small',
										value: 'Small'
									},
									{
										name: 'Medium',
										value: 'Medium'
									},
									{
										name: 'Large',
										value: 'Large'
									},
									{
										name: 'Very Large',
										value: 'Very Large'
									}
								]}
								onChange={ this.handleFiltersChange }
							/>
						}

						{ ( 'adopted' != page.template && ! subpage ) &&
							<Select
								id="shelter"
								label="Managing Branch"
								value={ filters.shelter }
								options={[
									{
										name: 'Any',
										value: ''
									},
									{
										name: 'Avon Valley',
										value: 'Avon Valley'
									},
									{
										name: 'Broome',
										value: 'Broome'
									},
									{
										name: 'Bunbury',
										value: 'Bunbury'
									},
									{
										name: 'Busselton',
										value: 'Busselton'
									},
									{
										name: 'Carnarvon',
										value: 'Carnarvon'
									},
									{
										name: 'Esperance',
										value: 'Esperance'
									},
									{
										name: 'Goldfields',
										value: 'Goldfields'
									},
									{
										name: 'Hedland',
										value: 'Hedland'
									},
									{
										name: 'Karratha',
										value: 'Karratha'
									},
									{
										name: 'Metro (Perth)',
										value: 'Metro'
									},
									{
										name: 'Newman',
										value: 'Newman'
									}
								]}
								onChange={ this.handleFiltersChange }
							/>
						}

						{ ( 'adopted' != page.template ) &&
						<Text
							id="postcode"
							label="Postcode"
							value={ postcode }
							onChange={ this.handlePostcodeChange }
						/>
						}

						{ ( 'adopted' != page.template ) &&
							<Select
								id="postcodeDistance"
								label="Distance from Postcode"
								value={ postcodeDistance }
								options={[
									{
										name: 'Within 50km',
										value: 50
									},
									{
										name: 'Within 100km',
										value: 100
									},
									{
										name: 'Within 200km',
										value: 200
									},
								]}
								onChange={ this.handlePostcodeDistanceChange }
							/>
						}

						{ ( 'adopted' != page.template && 'cat' == animalsType ) &&
							<Select
								id="age_range"
								label="Age"
								value={ filters.age_range }
								options={[
									{
										name: 'Any',
										value: ''
									},
									{
										name: 'Kitten',
										value: '6'
									},
									{
										name: 'Adult',
										value: '96'
									},
									{
										name: 'Senior',
										value: '96-up'
									},
								]}
								onChange={ this.handleFiltersChange }
							/>
						}

						{ ( 'adopted' != page.template && 'cat' != animalsType ) &&
							<Select
								id="age_range"
								label="Age"
								value={ filters.age_range }
								options={[
									{
										name: 'Any',
										value: ''
									},
									{
										name: 'Puppy',
										value: '6'
									},
									{
										name: 'Adult',
										value: '96'
									},
									{
										name: 'Senior',
										value: '96-up'
									},
								]}
								onChange={ this.handleFiltersChange }
							/>
						}

						{ ( 'adopted' != page.template ) &&
							<div className="-advanced" onClick={ this.handleClickAdvanced }>
								Advanced
							</div>
						}

						{ ( 'adopted' == page.template ) &&
							<Text
								id="search"
								label="Search by Name"
								value={ search }
								onChange={ this.handleSearchChange }
							/>
						}
					</div>

					<div className="-filters -filters-advanced">
						<div className="-inner">
							<Text
								id="search"
								label="Search by Name"
								value={ search }
								onChange={ this.handleSearchChange }
							/>

							<Select
								id="sex"
								label="Gender"
								value={ filters.sex }
								options={[
									{
										name: 'Any',
										value: ''
									},
									{
										name: 'Male',
										value: 'Male'
									},
									{
										name: 'Female',
										value: 'Female'
									}
								]}
								onChange={ this.handleFiltersChange }
							/>

							<Select
								id="breed"
								label="Breed"
								value={ filters.breed }
								options={ breeds }
								onChange={ this.handleFiltersChange }
							/>

							<div className="-checkboxes">
								<div>
									<Checkbox
										id="good_with_dogs"
										label="Good with Dogs"
										value={ filters.good_with_dogs }
										onChange={ this.handleFiltersChange }
									/>

									<Checkbox
										id="good_with_cats"
										label="Good with Cats"
										value={ filters.good_with_cats }
										onChange={ this.handleFiltersChange }
									/>

									<Checkbox
										id="lived_with_children"
										label="Has lived with children"
										value={ filters.lived_with_children }
										onChange={ this.handleFiltersChange }
									/>
								</div>

								<div>
									<Checkbox
										id="bonded_pair"
										label="Bonded pair"
										value={ filters.bonded_pair }
										onChange={ this.handleFiltersChange }
									/>

									<Checkbox
										id="special_needs"
										label="Special Needs"
										value={ filters.special_needs }
										onChange={ this.handleFiltersChange }
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let animalsById

	switch ( state.animals.animalsType ) {
		case 'cat':
			animalsById = state.animals.catsById
			break

		case 'other':
			animalsById = state.animals.otherById
			break

		default:
			animalsById = state.animals.dogsById
	}

	return {
		animalsById: animalsById,
		postcode: state.animals.postcode,
		postcodeDistance: state.animals.postcodeDistance,
		search: state.animals.search,
		filters: state.animals.filters,
		animalsType: state.animals.animalsType,
		page: currentPage( state )
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		setAnimalsSearch: ( value ) => {
			dispatch( setAnimalsSearch( value ) )
		},

		setAnimalsPostcode: ( value ) => {
			dispatch( setAnimalsPostcode( value ) )
		},

		setAnimalsPostcodeDistance: ( value ) => {
			dispatch( setAnimalsPostcodeDistance( value ) )
		},

		getLatLng: ( value ) => {
			dispatch( getLatLng( value ) )
		},

		setLatLng: ( value ) => {
			dispatch( setLatLng( value ) )
		},

		setAnimalsFilter: ( id, value ) => {
			dispatch( setAnimalsFilter( id, value ) )
		},

		setAnimalsType: ( type ) => {
			dispatch( setAnimalsType( type ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( AnimalsFilters )



// WEBPACK FOOTER //
// ./views/main/page/AnimalsFilters.jsx